import { Modal } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SModal = styled(Modal)``;
